import tinymce from "tinymce/tinymce"

import "tinymce/icons/default"
import "tinymce/themes/silver"
import "tinymce/plugins/fullscreen"
import "tinymce/plugins/autoresize"
import "tinymce/plugins/table"
import "tinymce/plugins/link"
import "tinymce/plugins/autolink"
import "tinymce/skins/ui/oxide/skin.css"
import "tinymce/skins/content/default/content.css"
import "tinymce/skins/ui/oxide/content.css"

const editorSelector = "textarea.tinymce"

function editorConfig(target) {
  const eventEditor = target.classList.contains("event-description-editor")
  const reportEditor = target.closest(".report-editor")
  return {
    target,
    plugins: eventEditor ? "link autolink autoresize" : (reportEditor ? "table fullscreen autoresize" : "table fullscreen"),
    ...(reportEditor ? { min_height: 180, autoresize_bottom_margin: 16, toolbar_mode: "wrap" } : {}),
    toolbar: eventEditor ? "undo redo | bold italic | link unlink" : "undo redo | formatselect | bold italic | alignleft aligncenter alignright | bullist numlist | table | fullscreen",
    ...(eventEditor ? {
      min_height: 220,
      autoresize_bottom_margin: 16,
      toolbar_mode: "wrap",
      link_title: false,
      content_style: "body { font-family: 'Open Sans', sans-serif; font-size: 14px; line-height: 1.5; color: #212529; } a { color: #ce4f0e; }",
    } : {}),
    menubar: false,
    statusbar: true,
    branding: false,
    skin: false,
    content_css: false,
    promotion: false,
    setup(editor) {
      // Editor content lives in an iframe, outside the document's activity listeners.
      editor.on("keydown input mousedown touchstart scroll", event => {
        if (event.isTrusted) document.dispatchEvent(new CustomEvent("session:activity"))
      })
      editor.on("init", () => {
        target.dispatchEvent(new CustomEvent("editor:initialized", { bubbles: true }))
      })
      editor.on("change input undo redo", () => {
        editor.save()
        target.dispatchEvent(new CustomEvent("editor:change", { bubbles: true }))
      })
    },
  }
}

export function initializeTinyMce(root = document) {
  root.querySelectorAll(editorSelector).forEach((textarea) => {
    if (textarea.closest('.report-template-management') && textarea.closest('details:not([open])')) return
    if (textarea.dataset.tinymceInitialized === "true") return

    textarea.dataset.tinymceInitialized = "true"
    tinymce.init(editorConfig(textarea))
  })
}

export function removeTinyMce(root = document) {
  root.querySelectorAll(editorSelector).forEach((textarea) => {
    const editor = tinymce.get(textarea.id)
    if (editor && editor.getElement() === textarea) editor.remove()
    delete textarea.dataset.tinymceInitialized
  })
}

document.addEventListener("DOMContentLoaded", () => initializeTinyMce())
document.addEventListener("turbolinks:load", () => initializeTinyMce())
document.addEventListener("turbolinks:before-cache", () => removeTinyMce())

window.tinymce = tinymce
